import React, { FunctionComponent } from "react"
import { useTranslation } from "react-i18next"

import Modal from "components/Modal/Modal"
import PictureGallery, { IPictureGalleryProps } from "components/PictureGallery/PictureGallery"

interface IPictureGalleryModalProps {
    pictureGallery: IPictureGalleryProps
    onClose(): void
}

const PictureGalleryModal: FunctionComponent<React.PropsWithChildren<IPictureGalleryModalProps>> = ({
    pictureGallery,
    onClose
}) => {
    const { t } = useTranslation()

    return (
        <Modal
            title={t('pictureGalleryModal.title')}
            onClose={onClose}
            width="1000px">
            <PictureGallery {...pictureGallery} />
        </Modal>
    )
}

export default PictureGalleryModal
